import React from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-multi-lang";
import { useSelector } from "react-redux";

import SettlementMode from "./SettlementMode";
import StatusBadge from "./StatusBadge";

import { display } from "../Utility/Utility";

const ViewSettlementModal = ({ settlement, onHide }) => {
  const t = useTranslation("settlement.settlement_modal");
  const profile = useSelector((state) => state.admin.profile);

  if (!settlement) return null;

  const {
    unique_id,
    payment_id,
    amount,
    opening_balance,
    closing_balance,
    created_at,
    updated_at,
    status_formatted,
  } = settlement;

  const showLedger = profile?.data?.show_payin_ledger && (status_formatted || "").toUpperCase() === "PAID";

  return (
    <Offcanvas show={!!settlement} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{t("settlement_details")}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="view-modal-wrap">

          {/* BASIC DETAILS */}
          <div className="view-modal-card-wrap">

            <div className="view-modal-card">
              <div>{t("unique_id")}</div>
              <div>{display(unique_id)}</div>
            </div>

            <div className="view-modal-card">
              <div>{t("payment_id")}</div>
              <div>{display(payment_id)}</div>
            </div>

            <div className="view-modal-card">
              <div>{t("amount")}</div>
              <div>{display(amount)}</div>
            </div>

          </div>

          {/* PAYIN LEDGER (IF PAID) */}
          {showLedger == 1 && (
            <div className="view-modal-card-wrap">
              <div className="view-modal-card">
                <div>{t("opening_balance")}</div>
                <div>{display(opening_balance)}</div>
              </div>

              <div className="view-modal-card">
                <div>{t("closing_balance")}</div>
                <div>{display(closing_balance)}</div>
              </div>
            </div>
          )}

          {/* MODE OF SETTLEMENT DETAILS */}
          <SettlementMode settlement={settlement} />

          {/* STATUS */}
          <div className="view-modal-card">
            <div>{t("status")}</div>
            <StatusBadge status={status_formatted} />
          </div>

          {/* DATES */}
          <div className="view-modal-card">
            <div>{t("requested_date")}</div>
            <div>{display(created_at)}</div>
          </div>

          <div className="view-modal-card">
            <div>{t("last_updated_date")}</div>
            <div>{display(updated_at)}</div>
          </div>

        </div>
      </Offcanvas.Body>

    </Offcanvas>
  );
};

export default ViewSettlementModal;